import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { siteConfig } from "../siteConfig";

/*
  GoHighLevel survey embed — to swap to a different client's survey,
  replace SURVEY_SRC with the iframe src from their embed code.
*/
const SURVEY_SRC = "https://links.soardigital.co/widget/survey/AzZJEHtjBbfFbAg0gqAn";
const SURVEY_ID = "AzZJEHtjBbfFbAg0gqAn";

/* Background photo — kept distinct from the homepage hero/CTA image */
const BG_IMAGE =
  siteConfig.services.find((s) => s.slug === "commercial-construction")?.image ||
  siteConfig.cta.image;

const ReviewSurveyPage = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (document.querySelector('script[src="https://links.soardigital.co/js/form_embed.js"]')) return;
    const script = document.createElement("script");
    script.src = "https://links.soardigital.co/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center pt-32 pb-20 px-5 overflow-hidden">
      {/* Background photo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />
      <div className="absolute inset-0" style={{ background: "rgba(4,12,4,0.80)" }} />

      <div className="relative z-10 text-center mb-10 max-w-xl">
        <p
          className="text-xs font-black uppercase tracking-widest mb-3"
          style={{ color: siteConfig.colors.primary }}
        >
          Share Your Experience
        </p>
        <h1
          className="font-display font-black text-white leading-tight mb-4"
          style={{ fontSize: "clamp(2.2rem,5vw,3.5rem)" }}
        >
          How Did We Do?
        </h1>
        <p className="text-white/60 text-base">
          Your feedback means everything to us. It takes less than 30 seconds.
        </p>
      </div>

      <div className="relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-xl overflow-hidden">
        {!loaded && (
          <div
            className="absolute inset-0 flex flex-col items-center justify-center gap-3"
            style={{ minHeight: "420px" }}
          >
            <Loader2 className="w-6 h-6 animate-spin" style={{ color: siteConfig.colors.primary }} />
            <p className="text-sm font-medium text-gray-400">Loading...</p>
          </div>
        )}
        <iframe
          src={SURVEY_SRC}
          style={{ border: "none", width: "100%", display: "block", opacity: loaded ? 1 : 0, minHeight: loaded ? undefined : "420px" }}
          scrolling="no"
          id={SURVEY_ID}
          title="survey"
          onLoad={() => setLoaded(true)}
        />
      </div>
    </section>
  );
};

export default ReviewSurveyPage;
